export enum LayoutActionTypes {
  STRUCTURE_CHANGED = 'layout/STRUCTURE_CHANGED',
}
